import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'idea-vision',
  templateUrl: './idea-vision.component.html',
  styleUrls: ['./idea-vision.component.scss']
})
export class IdeaVisionComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}
